import React, { Fragment, useEffect } from 'react';
import {
    changeNameP1T4,
    changeCredentialsP1T4,
    changeTitle1P1T4,
    changeDepartment1P1T4,
    changeDepartment2P1T4,
    changeDepartment3P1T5,
    changePhoneP1T4,
    changeFaxP1T4,
    changeAddressP1T4,
    changeAddress2P1T4,
    changeAddress3P1T4,
    changeCityP1T4,
    changeStateP1T4,
    changeZipP1T4,
    changeLocationNamesP1T6,
    changeLocationPhonesP1T6,
    changeLocationFaxesP1T6,
    changeLocationAddresses1P1T6,
    changeLocationAddresses2P1T6,
    changeLocationCitiesP1T6,
    changeLocationStatesP1T6,
    changeLocationZipsP1T6,
} from './../CanvasActions';
import TextField from './../Form/TextField';
import SelectField from './../Form/SelectField';

const FormP1T6 = React.memo((props) => {
    useEffect(() => {
        changeNameP1T4(props.name);
    }, [props.name]);

    useEffect(() => {
        changeCredentialsP1T4(props.credentials);
    }, [props.credentials]);

    useEffect(() => {
        changeTitle1P1T4(props.title1);
    }, [props.title1]);

    useEffect(() => {
        changeDepartment1P1T4(props.department1);
    }, [props.department1]);

    useEffect(() => {
        changeDepartment2P1T4(props.department2);
    }, [props.department2]);

    useEffect(() => {
        changeDepartment3P1T5(props.department3);
    }, [props.department3]);

    useEffect(() => {
        changePhoneP1T4(props.phone);
    }, [props.phone]);

    useEffect(() => {
        changeFaxP1T4(props.fax);
    }, [props.fax]);

    useEffect(() => {
        changeAddressP1T4(props.address);
    }, [props.address]);

    useEffect(() => {
        changeAddress2P1T4(props.address2);
    }, [props.address2]);

    useEffect(() => {
        changeAddress3P1T4(props.address3);
    }, [props.address3]);

    useEffect(() => {
        changeCityP1T4(props.city);
    }, [props.city]);

    useEffect(() => {
        changeStateP1T4(props.state);
    }, [props.state]);

    useEffect(() => {
        changeZipP1T4(props.zip);
    }, [props.zip]);

    useEffect(() => {
        changeLocationNamesP1T6(props.locationNames);
    }, [props.locationNames]);

    useEffect(() => {
        changeLocationPhonesP1T6(props.locationPhones);
    }, [props.locationPhones]);

    useEffect(() => {
        changeLocationFaxesP1T6(props.locationFaxes);
    }, [props.locationFaxes]);

    useEffect(() => {
        changeLocationAddresses1P1T6(props.locationAddresses1);
    }, [props.locationAddresses1]);

    useEffect(() => {
        changeLocationAddresses2P1T6(props.locationAddresses2);
    }, [props.locationAddresses2]);

    useEffect(() => {
        changeLocationCitiesP1T6(props.locationCities);
    }, [props.locationCities]);

    useEffect(() => {
        changeLocationStatesP1T6(props.locationStates);
    }, [props.locationStates]);

    useEffect(() => {
        changeLocationZipsP1T6(props.locationZips);
    }, [props.locationZips]);

    const setLocationElement = (elements, setFunction, index, value) => {
        const elementsCopy = [...elements];
        elementsCopy[index] = value;
        setFunction(elementsCopy);
    };

    const renderLocations = () => {
        let elements = [];
        for (let i = 0; i < 2; i++) {
            elements.push(
                <Fragment>
                    <h6>Location {i + 1}:</h6>
                    <TextField
                        required={i === 0}
                        label="Name"
                        value={props.locationNames[i]}
                        setFunction={setLocationElement.bind(this, props.locationNames, props.setLocationNames, i)}
                    />
                    <TextField
                        required={i === 0}
                        label="Address Line 1"
                        value={props.locationAddresses1[i]}
                        setFunction={setLocationElement.bind(this, props.locationAddresses1, props.setLocationAddresses1, i)}
                    />
                    <TextField
                        label="Address Line 2"
                        value={props.locationAddresses2[i]}
                        setFunction={setLocationElement.bind(this, props.locationAddresses2, props.setLocationAddresses2, i)}
                    />
                    <TextField
                        required={i === 0}
                        label="City"
                        value={props.locationCities[i]}
                        setFunction={setLocationElement.bind(this, props.locationCities, props.setLocationCities, i)}
                    />
                    <TextField
                        required={i === 0}
                        label="State"
                        value={props.locationStates[i]}
                        setFunction={setLocationElement.bind(this, props.locationStates, props.setLocationStates, i)}
                    />
                    <TextField
                        required={i === 0}
                        label="Zip"
                        value={props.locationZips[i]}
                        setFunction={setLocationElement.bind(this, props.locationZips, props.setLocationZips, i)}
                    />
                    <TextField
                        required={i === 0}
                        isPhone
                        label="Phone"
                        value={props.locationPhones[i]}
                        setFunction={setLocationElement.bind(this, props.locationPhones, props.setLocationPhones, i)}
                    />
                    <TextField
                        isPhone
                        label="Fax"
                        value={props.locationFaxes[i]}
                        setFunction={setLocationElement.bind(this, props.locationFaxes, props.setLocationFaxes, i)}
                    />
                </Fragment>
            );
        }

        return elements;
    };

    return (
        <form action="">
            <hr />
            <TextField
                required
                label="Name"
                value={props.name}
                setFunction={props.setName}
            />
            <TextField
                label="Credentials"
                value={props.credentials}
                setFunction={props.setCredentials}
            />
            <TextField
                required
                label="Title 1"
                value={props.title1}
                setFunction={props.setTitle1}
                placeholder="Primary title (employee or faculty position)"
            />
            <hr />
            <TextField
                required
                label="Department 1"
                value={props.department1}
                setFunction={props.setDepartment1}
                placeholder="Department/Division/Center Name"
            />
            <TextField
                label="Department 2"
                value={props.department2}
                setFunction={props.setDepartment2}
                placeholder="Department/Division/Center Second line"
            />
            <TextField
                label="Department 3"
                value={props.department3}
                setFunction={props.setDepartment3}
                placeholder="Department/Division/Center Second line"
            />
            <hr />
            {renderLocations()}
            <hr />
            <SelectField
                required
                label="Quantity"
                value={props.quantity}
                setFunction={props.setQuantity}
                options={[
                    { value: '', label: 'Select option' },
                    { value: '250', label: '250' },
                    { value: '500', label: '500' },
                    { value: '1000', label: '1000' },
                ]}
            />
            <hr />
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> Memorial Hermann Heart & Vascular Institute / UTHealth Medical School</div>
                <div className="description-list">
                    <span className="label">Description:</span>
                    <ul>
                        <li>Variables both sides</li>
                        <li>Size 3.5x2</li>
                        <li>Double sided </li>
                        <li>Color on both sides</li>
                        <li>#80 Avalanche Smooth Cover</li>
                    </ul>
                </div>
            </div>
        </form>
    );
});

FormP1T6.propTypes = {

}

export default FormP1T6;
